import React from "react";
import type { ConnectedCustomAppsStore } from "src/customApps/ai/connectedCustomApps.ts";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

/** Open Custom Apps that offer AI tools, and their connection to an AI conversation. */
export const ConnectedCustomAppsContext = React.createContext<ConnectedCustomAppsStore | undefined>(undefined);

export const useConnectedCustomApps = () => useContextOrThrow(ConnectedCustomAppsContext);
